import { SetupPage, TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { DataRewards } from '../../../data-rewards.setup';

const parent: SetupPage = DataRewards.pages.offersDatabackManagement;
const path = 'databack';
const title = 'PAGE.DATA_REWARDS.OFFERS_DATABACK_MANAGEMENT.DATABACK.TITLE';

const res = [
  'createCampaign',
  'actions',
  'actions.viewDetails',
  'actions.pauseCampaign',
  'actions.deleteCampaign',
  'actions.activateCampaign',
];

export const DataRewardsDatabackTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
